import { FC } from 'react';
import { LabelTransformer, DiffBase, DiffBaseProps } from '../diff-base';
import * as Styled from './enum-candidate-preoffer-info-diff.styles';
import { useTranslation } from 'react-i18next';
import { EnumCandidatePreofferInfoDataFields } from '@innowise-group/core';

interface EnumCandidatePreofferInfoDiff extends Omit<DiffBaseProps, 'labelTransformer'> {
  fieldName: EnumCandidatePreofferInfoDataFields;
}

const EnumCandidatePreofferInfoDiff: FC<EnumCandidatePreofferInfoDiff> = (props) => {
  const { fieldName } = props;
  const labelTransformer: LabelTransformer<typeof fieldName> = ({ data }, index) => {
    const { t } = useTranslation();

    return (
      <Styled.OptionWrapper key={index}>
        <Styled.LabelAndValueWrapper>
          <Styled.Value>{data ? t(`options.gradeOptions_${data}`) : t('buttons.leaveBlank')}</Styled.Value>{' '}
        </Styled.LabelAndValueWrapper>
      </Styled.OptionWrapper>
    );
  };
  return <DiffBase labelTransformer={labelTransformer} {...props} />;
};

export default EnumCandidatePreofferInfoDiff;
